import { render } from "./coupons.vue?vue&type=template&id=5b0f40a0&ts=true"
import script from "./coupons.vue?vue&type=script&lang=ts"
export * from "./coupons.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__